import type { WhatsappChat } from "../../types.ts";
import { AccountChip } from "../AccountSwitcher.tsx";
import { hashHue, messageAckKind } from "../Chat.helpers.ts";
import { icons } from "./icons.ts";

export function ChatAvatar({
  chat,
  display,
  large = false,
  avatarUrl = null,
  onClick,
}: {
  chat: WhatsappChat;
  display: string;
  large?: boolean;
  avatarUrl?: string | null;
  onClick?: () => void;
}) {
  const initial = (display || "?").trim().slice(0, 1).toUpperCase();
  const hue = hashHue(chat.chatJid || display);
  const sessionId = chat.accountSessionId;
  const avatarClass = `wa-avatar ${large ? "wa-avatar-md" : ""}`;
  const avatarStyle = { background: `hsl(${hue}, 36%, 78%)`, color: `hsl(${hue}, 60%, 25%)` };
  const avatarContent = avatarUrl ? <img className="wa-avatar-img" src={avatarUrl} alt="" /> : initial;

  return (
    <div className={`wa-avatar-wrap ${large ? "wa-avatar-wrap-md" : ""}`}>
      {avatarUrl && onClick ? (
        <button
          className={`${avatarClass} wa-avatar-btn`}
          style={avatarStyle}
          type="button"
          title="Expandir foto do perfil"
          aria-label="Expandir foto do perfil"
          onClick={onClick}
        >
          {avatarContent}
        </button>
      ) : (
        <div className={avatarClass} style={avatarStyle}>
          {avatarContent}
        </div>
      )}
      <AccountChip sessionId={sessionId} variant="overlay" />
    </div>
  );
}

export function MessageAck({ fromMe, status }: { fromMe?: boolean; status?: number }) {
  if (!fromMe) return null;
  const kind = messageAckKind(status);
  if (kind === "read") return <span className="wa-ack wa-ack-read"><SvgIcon svg={icons.doubleCheck} /></span>;
  if (kind === "delivered") return <span className="wa-ack"><SvgIcon svg={icons.doubleCheck} /></span>;
  if (kind === "sent") return <span className="wa-ack"><SvgIcon svg={icons.singleCheck} /></span>;
  return <span className="wa-ack wa-ack-pending"><SvgIcon svg={icons.clock} /></span>;
}

export function SvgIcon({ svg }: { svg: string }) {
  return <span aria-hidden="true" dangerouslySetInnerHTML={{ __html: svg }} />;
}
